// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0624a9c7","453":"00eeb7eb","667":"f4d98c66","857":"4f006a23"}[chunkId] + ".chunk.js";
};